export default __webpack_public_path__ + "static/media/bfd228dbc960f9a45aedeb284828b310.svg";